// extracted by mini-css-extract-plugin
module.exports = {"body":"PhonePhotoDialog_body__Zu09F","qrPanel":"PhonePhotoDialog_qrPanel__pHpDL"};